import { Lightning, Router } from '@lightningjs/sdk'

import SplashVideo from '../components/SplashVideo/SplashVideo'
import { FIRST_LANDING, HOME } from '../constants/routes'
import { redirectHandler } from '../lib/routes'
import { AppConfig } from '../services/appConfig'
import { getRefreshToken, storeUserData, updateUserSubscriptionData } from '../utils/authentication'
import { getDeeplinkPath } from '../utils/deeplinkUtils'

export default class Splash extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      alpha: 1,
      SplashVideo: {
        type: SplashVideo,
        signals: {
          redirectToLanding: 'redirectToLandingOrHome',
        },
      },
    }
  }

  async redirectToLandingOrHome() {
    // Check if we're already authenticated and if so try to refresh the auth token
    const refreshToken = getRefreshToken()
    const deeplinkPath = getDeeplinkPath()

    if (refreshToken) {
      const data = await AppConfig.shared.authService.refreshToken({ token: refreshToken })
      if (data?.token && data?.refresh_token) {
        storeUserData(data)
        await updateUserSubscriptionData()

        if (!deeplinkPath) {
          Router.navigate(HOME)
          return
        }
      }
    }

    if (!deeplinkPath) {
      Router.navigate(FIRST_LANDING)
      return
    }

    redirectHandler(deeplinkPath)
  }
}
